import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { NavigationClose } from "../../icons";

import { createStyles } from "./styles";

var Toast = function Toast(props) {
  var show = props.show,onClose = props.onClose,colorType = props.colorType,children = props.children,className = props.className,_props$id = props.id,id = _props$id === void 0 ? '' : _props$id;

  var _useState = useState(false),_useState2 = _slicedToArray(_useState, 2),hideToast = _useState2[0],setHideToast = _useState2[1]; // for showing slide up animation

  var keyPressHandler = function keyPressHandler(e) {
    if (e.keyCode === 27) {
      onClose();
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', keyPressHandler);
    return function () {
      document.removeEventListener('keydown', keyPressHandler);
    };
  }, []);

  useEffect(function () {
    var hideTimeoutId;
    var closeTimeoutId;

    if (!show) setHideToast(false);
    if (show) {
      hideTimeoutId = setTimeout(function () {
        setHideToast(true);
        closeTimeoutId = setTimeout(function () {
          onClose();
        }, 1000);
      }, 4000);
    }
    return function () {
      clearTimeout(hideTimeoutId);
      clearTimeout(closeTimeoutId);
    };
  }, [show]);

  var classes = createStyles(props);
  return show ? /*#__PURE__*/
  React.createElement("div", {
    id: id,
    className: clsx(
    classes.toast,
    classes.showToast,
    hideToast && classes.hideToast,
    colorType ? classes[colorType] : classes.custom,
    className) }, /*#__PURE__*/


  React.createElement("div", { className: classes.toastText }, children), /*#__PURE__*/
  React.createElement("span", {
    role: "button",
    onKeyDown: keyPressHandler,
    tabIndex: 0,
    onClick: onClose,
    className: classes.toastCloseIcon }, /*#__PURE__*/

  React.createElement(NavigationClose, null))) :


  null;
};
Toast.displayName = 'Toast';

export default Toast;
//# sourceMappingURL=index.js.map